import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'hospitality-bot-sidebar-header',
  templateUrl: './sidebar-header.component.html',
  styleUrls: ['./sidebar-header.component.scss'],
})
export class SidebarHeaderComponent {
  @Input() title: string = '';
  @Input() heading?: string;
  @Input() icon?: string;
  @Input() showClose: boolean = true;
  @Input() closeIcon: string = 'assets/svg/close-sidebar.svg';
  @Input() closeTooltip: string = 'Close';

  @Output() onClose = new EventEmitter<void>();
  @Output() onModalClose = new EventEmitter<void>();

  get displayTitle(): string {
    return this.title || this.heading || '';
  }

  close(): void {
    this.onClose.emit();
    this.onModalClose.emit();
  }
}
